import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";

import { Grid, Button, TextField ,Typography} from "@material-ui/core";
const XERO_KEY = process.env.REACT_APP_XERO_CLIENT_ID;
const XERO_REDIRECT_URL = process.env.REACT_APP_XERO_REDIRECT_URI;
import ConfirmationModal from "../../components/modal/ConfirmationModal.js";
import ConfirmationModalCheckboxBasic  from "../../components/modal/ConfirmationModalCheckboxBasic.js";
import { withRouter } from "react-router-dom";

@inject("authStore","xeroStore", "templateStore", "userStore","profileStore")
@withRouter
@observer
class ConnectedAccount extends Component {
    state = {
        xeroActive: false,
        xeroAccount: "",
        showXeroDisconnectModal: false,
        openFirstConfirmationXeroDialog: false,
        xeroReset: false
    };

    componentDidMount = () => {
        this.props.authStore.reset();

        this.props.userStore.getUserCognito()

        let currentProfile = this.props.profileStore.getCurrentProfile();

        if(!currentProfile.hasOrganisation || currentProfile?.isOwnOrganization){
            this.setState({
                xeroActive: currentProfile?.activateXeroAccess,
                xeroAccount: currentProfile?.xeroTenantName
            });
        }else{
            this.setState({
                xeroActive: currentProfile?.organisationOwner?.activateXeroAccess,
                xeroAccount: currentProfile?.organisationOwner?.xeroTenantName
            });
        }
        
    };
    handleCloseXeroModal = () => this.setState({ ...this.state, showXeroDisconnectModal: false });
    handleOpenXeroModal = (xeroReset) => this.setState({ ...this.state, showXeroDisconnectModal: true, xeroReset: xeroReset, openFirstConfirmationXeroDialog: false });

    handleCloseFirstXeroModal = () => this.setState({ ...this.state, openFirstConfirmationXeroDialog: false, xeroReset: false });
    handleOpenFirstXeroModal = () => this.setState({ ...this.state, openFirstConfirmationXeroDialog: true });

    handleDisconnectXeroOpt1 = checked => {
        this.handleOpenXeroModal(checked)
    }

    handleDisconnectXero = e => {
        let currentProfile = this.props.profileStore.getCurrentProfile();
        this.props.templateStore.showLoadingScreen()
        if(!currentProfile.hasOrganisation || currentProfile?.isOwnOrganization){
           
        }else{
            currentProfile = currentProfile?.organisationOwner
        }
        this.props.xeroStore.disconnect(currentProfile.id,  this.state.xeroReset).finally(() => {
            this.props.profileStore.loadProfiles().finally(() => {
                this.props.templateStore.hideLoadingScreen()
                this.props.history.push("/account/setting/xero")
            })
         
        });
    }

    render() {
        const {xeroActive,xeroAccount} = this.state
        const { currentUser } = this.props.userStore;
        var stringText = this.state.xeroReset ? `By disconnecting your account, you will no longer be able to sync your customer invoices and supplier bills between Hot Giggity and Xero. </br>
        You have also chosen to delete synchronisation data - this cannot be undone. </br>
        Do you want to continue?` : `By disconnecting your account, you will no longer be able to sync your customer invoices and supplier bills between Hot Giggity and Xero. </br>
        Do you want to continue?`
        return (
            <div>
                <Grid item md={12} style={{ marginTop: 25 }}>
                            <Grid container spacing={0}>
                                <Grid item md={12}>
                                    <Grid container spacing={8}>
                                        <Grid item md={3} xs={12}  spacing={0}
                                            direction="column"
                                            alignItems="center"
                                            justify="center" style={{ textAlign: "left", borderRight:"solid 1px"}}>
                                            
                                            <Typography gutterBottom>
                                                Connect your Hotgiggity Account to your XERO account
                                            </Typography>
                                        </Grid>
                                        <Grid item md={9} xs={12}  container
                                            spacing={0}
                                            direction="column"
                                            alignItems="center"
                                            justify="center" style={{paddingLeft:"15px",textAlign: "left",verticalAlign:"middle" }}>
                                                
                                                <Grid container spacing={2}>
                                                      
                                                      <Grid item md={6}>
                                                          <Typography gutterBottom>Step 1. Connect Hot Giggity to your XERO account</Typography>
                                                          {
                                                                      xeroActive ?  <Typography style={{color:"grey",fontSize: "0.725rem"}}gutterBottom>STATUS: Successfully connected</Typography> :
                                                                      <Typography style={{color:"grey",fontSize: "0.725rem"}}gutterBottom>STATUS: XERO not connected</Typography>
                                                          }
                                                          
                                                      </Grid>
                                                      
                                                      <Grid item md={6} style={{textAlign:"center"}}>
                                                          {
                                                              xeroActive ? 
                                                              <Fragment>
                                                                  <Button variant="contained" style={{ marginTop: 25, marginLeft: 10 }} color="primary" onClick={this.handleOpenFirstXeroModal} >
                                                                      Disconnect
                                                                  </Button>
                                                                  <Button
                                                                      variant="contained" style={{ marginTop: 25, marginLeft: 10 }} color="secondary"
                                                                      target="_blank"
                                                                      href={`https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${XERO_KEY}&redirect_uri=${XERO_REDIRECT_URL}&scope=offline_access openid profile email accounting.settings accounting.transactions accounting.contacts accounting.attachments payroll.employees payroll.payslip payroll.settings payroll.payruns&state=123`}
                                                                  >
                                                                      Reconnect
                                                                  </Button>
                                                              </Fragment> :
                                                              <Button
                                                                  variant="contained" style={{ marginTop: 25, marginLeft: 10 }} color="primary"
                                                                  target="_blank"
                                                                  href={`
                                                                  https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${XERO_KEY}&redirect_uri=${XERO_REDIRECT_URL}&scope=offline_access openid profile email accounting.settings accounting.transactions accounting.contacts accounting.attachments payroll.employees payroll.payslip payroll.settings payroll.payruns&state=123
                                                                      `}
                                                              >
                                                                  Connect XERO Account
                                                              </Button>
                                                          }
                                                              

                                                      </Grid>

                                                  </Grid> 
                                            </Grid>
                                    </Grid>

                                               
                                </Grid>
                            </Grid>
                            
                        </Grid>
                <ConfirmationModal
                    open={this.state.showXeroDisconnectModal}
                    title="Are you sure you want to disconnect your xero account?"
                    message={stringText}
                    closeHandler={this.handleCloseXeroModal}
                    confirmationHandler={this.handleDisconnectXero}
                    declineHandler={this.handleCloseXeroModal}
                    confirmationLabel="Disconnect"
                    declineLabel="Cancel"
                    maxWidth="sm"
                />
                <ConfirmationModalCheckboxBasic
                                            open={this.state.openFirstConfirmationXeroDialog}
                                            title="Disconnect Xero Connection"
                                            message="You're about to disconnect your Xero account from Hot Giggity. This will stop all future synchronisation between the two platforms. "
                                            // closeHandler={this.handleCloseDialogInvoiceCreated}
                                            // confirmationHandler={this.handleRedirectPopup}
                                            // declineHandler={this.handleCloseDialogInvoiceCreated}
                                            closeHandler={this.handleCloseFirstXeroModal}
                                            declineHandler={this.handleCloseFirstXeroModal}
                                            confirmationHandler={this.handleDisconnectXeroOpt1}
                                            confirmationLabel="Disconnect Xero"
                                            declineLabel="Cancel"
                                            maxWidth="sm"
                                        />   
            </div>
        );
    }
}

export default ConnectedAccount;
